import { HealthTracker } from 'src/models/healthTrackers/HealthTracker';
import { formatFriendlyDate } from 'src/utils/friendlyDateFormatter';
import { useHealthTrackerCardStyles } from './HealthTrackerCard.styles';

interface HealthTrackerCardProps {
  healthTracker: HealthTracker
  icon: React.ElementType
  color: string
}

const HealthTrackerCard: React.FC<HealthTrackerCardProps>
= ({ healthTracker, icon: Icon, color }: HealthTrackerCardProps) => {
  const styles = useHealthTrackerCardStyles();
  const mostRecentEntry = healthTracker.entries[0];
  const friendlyFormattedDate = mostRecentEntry.date && formatFriendlyDate(mostRecentEntry.date);

  return (
    <div className={styles.card} data-testid="health-tracker-card">
      <section data-testid="health-tracker-card-header">
        <div className={styles.iconContainer} data-testid="health-tracker-card-icon">
          {Icon && <Icon color={color} />}
        </div>

        <h3 className={styles.consumerName} style={{ color }} data-testid="health-tracker-card-title">
          {healthTracker.consumerName}
        </h3>
      </section>

      <p className={styles.date}>{friendlyFormattedDate}</p>

      <div className={styles.valueRow}>
        <span className={styles.value} data-testid="health-tracker-card-value">{mostRecentEntry.value}</span>

        <span className={styles.unit} data-testid="health-tracker-card-unit">{mostRecentEntry.unit}</span>
      </div>
    </div>
  );
};

export default HealthTrackerCard;
